var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"TempRoutePate"},_vm._l((_vm.routeList),function(data,i){return _c('div',{key:`page${i}`},[_c('a',{attrs:{"href":`#${data.path}`}},[_vm._v(_vm._s(data.name))])])}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }